export default "__VITE_ASSET__DamrSKWF__"